import "./globalOuterLayout.scss";
interface GlobalOuterLayoutProps {
    children?: React.ReactNode;
}

const GlobalOuterLayout: React.FC<GlobalOuterLayoutProps> = ({ children }) => {
    return (
        <div className="global-outer-layout">
            {children}
        </div>
    );
};

export default GlobalOuterLayout;